/* eslint-disable */
import React from 'react';
import { Box, Typography } from '@mui/material';

const SectionCard = ({ id, title, subtitle, children }) => (
  <Box
    id={id}
    sx={{
      backgroundColor: '#fff',
      borderRadius: '8px',
      border: '1px solid #D1D5DB',
      p: '14px 10px',
      mb: '20px',
      scrollMarginTop: '90px',
    }}
  >
    <Typography sx={{ fontSize: '20px', fontWeight: 700, color: '#000000', mb: subtitle ? '-2px' : '20px' }}>
      {title}
    </Typography>
    {subtitle && (
      <Box sx={{ fontSize: '14px', color: '#385576',fontweight:600, mb: '12px' }}>
        {subtitle}
      </Box>
    )}
    {children}
  </Box>
);

export default SectionCard;